import { resolveConfidenceVisitorId } from "@helpers/confidenceVisitorId"
import { Confidence } from "@spotify-confidence/sdk"

export const CURRENT_CONFIDENCE_FLAG = "fy-feedback-trust-preview"

/**
 * Explicit list of variants for the current A/B test.
 *
 * This is the single source of truth consumed by
 * `scripts/create-confidence-experiment.ts`, which regex-parses this file as
 * text (it can't import from the web app build). Knip doesn't see that
 * runtime read, so this export is tagged `@public` to keep it.
 *
 * Keep in sync with the loader/router switches — the review agent verifies
 * parity. First entry MUST be "baseline". Treatments use `v1`, `v2`, ...
 *
 * @public
 */
export const CURRENT_VARIANTS = ["baseline", "v1", "v2", "v3"] as const

export const confidence = Confidence.create({
  clientSecret: import.meta.env.VITE_CONFIDENCE_CLIENT_SECRET as string,
  environment: "client",
  region: "eu",
  timeout: 1000,
})

// Set directly rather than through the SDK's visitorIdentity() tracker. That
// tracker re-read the cookie on every page load and minted a fresh uuid
// whenever it found none, so on the iOS in-app browsers that drop the cookie
// mid-document it produced a different randomisation unit per page view, which
// would quietly split any running test. resolveConfidenceVisitorId resolves one
// id per page load and prefers an existing one, so a returning visitor stays in
// the variant they were already served.
const visitorId = resolveConfidenceVisitorId()

if (visitorId) confidence.setContext({ visitor_id: visitorId })
